import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const CollectionDatasetAssignToast = ({ name }) => (
  <PositiveToast className="aridhia-collection-dataset-assigned-toast">
    <FormattedMessage id="toast.collection.dataset" values={{ name }} />
  </PositiveToast>
);

export default CollectionDatasetAssignToast;
